import {  StyledBgDarkPrimaryMixin } from "@/common/styles";
import { InmateInformationMixinCss } from "@/components/InmateHeader/styles";
import styled from "styled-components";
export const StyledUsersContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  .badge-value{
    --badge-background:#d1e2e4;
    --badge-color:#282c2d;
    display: inline-flex;
    padding: 0px 8px;
    font-weight:bold;
    line-height: 18px;
    background: var(--badge-background);
    color: var(--badge-color);
    border:1px solid rgba(0,0,0,0.06);
    border-radius: 6px;
    
    &.valid{
    --badge-background: #91f391;
    --badge-color: #045f04;
    }
    &.invalid{
    --badge-background: #efb49a;
    --badge-color: #300f00;
    }

   }

`
export const StyledUsersContent = styled.div`
  position: relative;
  display: flex;
  min-height: 500px;
  height:100%;
  z-index: 2;
  flex-direction: column;
  &.users-main-accent{
   border: 2px solid var(--accent);
  }
  &.users-main-content{
     background-color:var(--white);
    .ant-tabs-nav{
    margin-bottom:0;
    }
    .ant-tabs,
    .styled-tab-container{ 
    position: relative;
    height:100%;
    }
    .ant-tabs-content-holder {
        overflow: auto;
    }
         .ant-tabs-content-left .ant-tabs-tabpane{
          padding-left: 0px !important;
     }
  }
  .users-sections{
   padding:16px;
  }
`
export const StyledUsersTopBar = styled.div`
  display: flex;
  background-color:var(--bg-light-container);
  min-height:50px;
  align-items: center;
  padding:0px 10px;
  h3{
  margin-bottom:0;
  font-size:1.26rem;
  }
`

export const StyledUserHeaderSection = styled.div`
${StyledBgDarkPrimaryMixin}
padding:16px;
`
export const StyledUserFormGroup = styled.div`
${InmateInformationMixinCss}
align-items: self-start;
flex-direction: column;
padding:10px 15px;
.form-value-box{
 min-width:70px;
}
 .checkbox-control{
  .ant-checkbox-checked .ant-checkbox-inner{
     box-shadow: 0px 0px 1px 1px #000;
  }
 }

`